module.exports = __webpack_public_path__ + "img/MG.86f8e095.svg";